/*
 * Remedy AI finder (PRD H10). Scripted 5-question flow that recommends only from the
 * products configured in the section. Phase 5 swaps recommend() for the grounded LLM.
 * Lead capture: webhook (Make.com/n8n → WhatsApp API + Zoho CRM) with explicit consent,
 * otherwise a WhatsApp chat pre-filled with the routine.
 */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = ms => new Promise(r => setTimeout(r, reduce ? 0 : ms));
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (cents, trim) => (window.Sansu && Sansu.formatMoney) ? Sansu.formatMoney(cents, trim) : 'Rs ' + Math.round(cents / 100);

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-remedy-data]').textContent);
    const S = data.strings;
    const concerns = data.concerns.filter(c => c.label);
    const log = root.querySelector('[data-remedy-log]');
    const replies = root.querySelector('[data-remedy-replies]');
    let answers = {}, run = 0;

    const questions = [
      { key: 'concern', text: S.greeting, options: concerns.map((c, n) => ({ v: n, t: c.label })) },
      { key: 'since', text: S.qSince, options: [{ v: 'new', t: S.sinceNew }, { v: 'mid', t: S.sinceMid }, { v: 'long', t: S.sinceLong }] },
      { key: 'age', text: S.qAge, options: [{ v: '18', t: '18–30' }, { v: '31', t: '31–45' }, { v: '46', t: '46–60' }, { v: '60', t: '60+' }] },
      { key: 'format', text: S.qFormat, options: [{ v: 'juice', t: S.formatJuice }, { v: 'tablet', t: S.formatTablet }, { v: 'churan', t: S.formatChuran }, { v: 'any', t: S.formatAny }] },
      { key: 'caution', text: S.qCaution, options: [{ v: 'no', t: S.no }, { v: 'yes', t: S.yes }, { v: 'unsure', t: S.unsure }] }
    ];
    const formatMatch = {
      juice: /juice|\bras\b|vinegar|sirka|syrup|drink|kadha|asava|arishta|ristha|tonic/,
      tablet: /vati|tablet|capsule|\btab\b/,
      churan: /churan|churna|powder|chran/
    };
    const formatName = { juice: S.formatJuice, tablet: S.formatTablet, churan: S.formatChuran };

    function add(html, cls) {
      const el = document.createElement('div');
      el.className = cls; el.innerHTML = html;
      log.appendChild(el); log.scrollTop = log.scrollHeight;
      return el;
    }
    async function bot(text, id) {
      // the greeting appears at once, so the chat never sits empty; later replies "type" first
      if (log.children.length) {
        const typing = add('<i></i><i></i><i></i>', 'msg msg--bot msg--typing');
        typing.setAttribute('aria-hidden', 'true');
        await wait(550);
        typing.remove();
      }
      if (id !== run) return false;
      add(esc(text), 'msg msg--bot');
      return true;
    }
    function setReplies(opts, onPick) {
      replies.innerHTML = opts.map((o, n) => `<button type="button" class="chip" data-n="${n}">${esc(o.t)}</button>`).join('');
      replies.onclick = e => {
        const b = e.target.closest('button'); if (!b) return;
        replies.onclick = null; replies.innerHTML = '';
        onPick(opts[+b.dataset.n]);
      };
    }

    // The doctor-approved routine ("core") comes first. When the visitor wants one format, products of that
    // format from the concern's whole range are used, routine products before the rest; if the brand makes
    // none in that format, the routine is shown and the visitor is told why.
    function recommend() {
      const c = concerns[answers.concern];
      const re = formatMatch[answers.format];
      const avail = c.products.filter(p => p.available);
      const core = avail.filter(p => p.core);
      const base = core.length ? core : avail;
      if (!re) return { picks: base.slice(0, 2), fallback: false };
      const fits = avail.map((p, n) => ({ p, n })).filter(x => re.test(x.p.type + ' ' + x.p.title.toLowerCase()))
        .sort((a, b) => (b.p.core - a.p.core) || (b.p.rating - a.p.rating) || (a.n - b.n)).map(x => x.p);
      if (!fits.length) return { picks: base.slice(0, 2), fallback: true };
      const picks = fits.slice(0, 2);
      if (picks.length < 2) { const extra = base.find(p => p !== picks[0]); if (extra) picks.push(extra); }
      return { picks, fallback: false };
    }

    async function showRoutine(id) {
      const c = concerns[answers.concern];
      const { picks, fallback } = recommend();
      if (!picks.length) {
        await bot(S.noProducts, id);
        return offerHuman();
      }
      if (fallback && !(await bot(S.formatFallback.replace('__format__', (formatName[answers.format] || '').toLowerCase()), id))) return;
      if (!(await bot(S.routineIntro.replace('__concern__', c.label.toLowerCase()), id))) return;
      const total = picks.reduce((s, p) => s + p.price, 0);
      const caution = answers.caution !== 'no';
      const card = add(`
        <p class="label" style="margin-bottom:6px">${esc(S.routineTitle.replace('__concern__', c.label))}</p>
        ${picks.map(p => `<div class="routine__item"><div>${p.image ? `<img class="pack" src="${esc(p.image)}" alt="" loading="lazy" width="52" height="52">` : ''}</div>
          <div><strong>${esc(p.title)}</strong><span>${p.size ? esc(p.size) + ' · ' : ''}${esc(S.followDosage)}</span></div>
          <span class="mono">${money(p.price)}</span></div>`).join('')}
        <div class="routine__total"><span>${esc(S.routineTotal)}</span><span>${money(total)}</span></div>
        ${caution ? `<p class="msg msg--bot routine__caution">${esc(S.cautionNote)}</p>` : ''}
        <div class="routine__actions">
          <button class="btn btn--primary btn--sm btn--block" type="button" data-routine-add>${esc(S.addRoutine.replace('__price__', money(total)))}</button>
          ${data.webhook ? `
          <form class="wa-form" data-wa-form novalidate>
            <input type="tel" inputmode="numeric" maxlength="10" placeholder="${esc(S.waPlaceholder)}" aria-label="${esc(S.waPlaceholder)}" autocomplete="tel-national">
            <label class="consent"><input type="checkbox"> ${esc(S.waConsent)}</label>
            <button class="btn btn--ghost btn--sm btn--block" type="submit">${esc(S.waButton)}</button>
          </form>` : (data.whatsapp ? `<a class="btn btn--ghost btn--sm btn--block" target="_blank" rel="noopener" data-wa-link>${esc(S.waButton)}</a>` : '')}
        </div>
        <p class="fineprint">${esc(S.disclaimer)}</p>`, 'routine');

      const summary = `${S.routineTitle.replace('__concern__', c.label)}: ${picks.map(p => p.title).join(', ')}`;
      const addBtn = card.querySelector('[data-routine-add]');
      addBtn.addEventListener('click', async () => {
        addBtn.disabled = true; // the event's currentTarget is gone after the await, so keep our own reference
        try { await Sansu.cart.add(picks.map(p => ({ id: p.variantId, quantity: 1 }))); } finally { addBtn.disabled = false; }
      });
      const link = card.querySelector('[data-wa-link]');
      if (link) link.href = `https://wa.me/${data.whatsapp}?text=${encodeURIComponent(summary)}`;
      const form = card.querySelector('[data-wa-form]');
      if (form) form.addEventListener('submit', async e => {
        e.preventDefault();
        const tel = form.querySelector('input[type="tel"]'), ok = form.querySelector('input[type="checkbox"]');
        if (!/^[6-9]\d{9}$/.test(tel.value.trim())) { Sansu.toast(S.waInvalid); tel.focus(); return; }
        if (!ok.checked) { Sansu.toast(S.consentNeeded); ok.focus(); return; }
        try {
          await fetch(data.webhook, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone: '91' + tel.value.trim(), consent: true, source: 'remedy-ai', concern: c.handle, answers, products: picks.map(p => p.variantId), page: location.pathname })
          });
          form.innerHTML = `<p class="msg msg--user" style="max-width:none">${esc(S.waSaved)}</p>`;
        } catch (err) { Sansu.toast(Sansu.strings.error); }
      });
      offerHuman();
    }

    function offerHuman() {
      setReplies([{ t: S.talkPerson, v: 'human' }, { t: S.startOver, v: 'restart' }], o => {
        if (o.v === 'restart') return start();
        add(esc(o.t), 'msg msg--user');
        bot(S.talkReply, run);
      });
    }

    async function ask(n, id) {
      if (n >= questions.length) return showRoutine(id);
      const q = questions[n];
      if (!(await bot(q.text, id))) return;
      setReplies(q.options, o => {
        add(esc(o.t), 'msg msg--user');
        answers[q.key] = o.v;
        ask(n + 1, id);
      });
    }

    function start() {
      run++; answers = {};
      log.innerHTML = ''; replies.innerHTML = '';
      ask(0, run);
    }
    root.querySelector('[data-remedy-restart]').addEventListener('click', start);
    const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); start(); } }, { threshold: .3 });
    io.observe(root);
  }

  document.querySelectorAll('[data-remedy]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-remedy]').forEach(init));
})();
